import type { ImageLoader } from 'next/image';

import { IMAGE_PROXY_URL } from '@/Module/Core/Constant';

const imgProxyLoader: ImageLoader = ({ src, width, quality }) => {
  if (src?.includes('http://localhost')) return src;

  const url = [IMAGE_PROXY_URL];
  // TOKEN
  url.push('image');
  url.push(`w:${width}`);
  if (quality) url.push(`q:${quality}`);

  // Image type
  url.push('plain');
  url.push(encodeURI(src));
  return url.join('/');
};

export default imgProxyLoader;
